import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';

import { APP_BASE_LINK } from 'src/environments/constants';
import { Salesforce } from 'src/app/Services/Data/data.model';
import { DataService, Loading } from 'src/app/Services/Data/data.service';

@Component({
  selector: 'sn-sso-login-btn',
  templateUrl: './signnow-login-button.html',
  styleUrls: ['./signnow-login-button.sass']
})
export class SignNowLoginButtonComponent implements OnInit, OnDestroy {
  @Output() public loginEvent: EventEmitter<any> = new EventEmitter();
  userSFData: Salesforce;
  loading: Loading;
  errorMessage = '';
  sid;

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.loading = this.dataService.getLoading();
    this.userSFData = this.dataService.getSalesforceData();
  }

  emitLoginEvent() {
    this.loginEvent.emit();
  }

  openSnLoginFormAndHandleResult() {
    this.openSnLoginForm();
    this.checkAndHandleLoginResult();
  }

  openSnLoginForm() {
    this.loading.update(true, 'Logging In...');
    this.clearErrorMessage();

    const loginFormUrl = this.getLoginFormUrl();
    const windowProperties = 'scrollbars=yes,resizable=yes,top=100,left=100,width=750,height=750';

    window.open(loginFormUrl, '_blank', windowProperties);
  }

  logout_user() {
    const user_data = {
      sn_token: '',
      sn_refresh: '',
      sn_email: ''
    };

    this.dataService.apiPostCall('/api/update_user_db', JSON.stringify(user_data));
  }

  getLoginFormUrl() {
    const proxyUrl = this.userSFData.proxy_url;
    const redirectUrl = `${proxyUrl}/api/sn_oauth_callback?uuid=${this.userSFData.sf_user_id}`;
    const redirectUriParam = `redirect_uri=${redirectUrl}`;
    const clientParam = 'client_id=ee65b2c3b8d4f635fc3c6996f93c6a14';
    const responseTypeParam = 'response_type=code';
    const allParams = `${clientParam}&${responseTypeParam}&${redirectUriParam}`;

    return `${APP_BASE_LINK}/authorize?${allParams}`;
  }

  checkAndHandleLoginResult() {
    const interval = 5000;
    const maxTimeMinutes = 7;
    const maxTries = (60000 / interval) * maxTimeMinutes;
    let countOfTries = 0;

    this.sid = setInterval(() => {
      ++countOfTries;
      if (countOfTries > maxTries) {
        clearInterval(this.sid);
        this.loading.hide();
        this.setErrorMessage('Sorry, logging timeout. Please tyr again.');
      }

      this.checkUserData((result) => {
        if (result.sn_token && result.sn_email) {
          clearInterval(this.sid);
          this.loading.update(true, 'Logged in successfully');

          const userData = {
            sn_token: result.sn_token,
            sn_refresh: result.sn_refresh,
            sn_email: result.sn_email
          };

          this.loading.update(
            true,
            'Validating SignNow login credentials and updating user data on this account.'
          );
          this.dataService
            .apiPostCall('/api/update_user_db', JSON.stringify(userData))

            .subscribe(() => {
              this.emitLoginEvent();
            });
        }
      });
    }, interval);
  }

  checkUserData(callback) {
    this.dataService
      .apiGetCall(`/api/check_and_obtain_oauth_data?sf_user_id=${this.userSFData.sf_user_id}`)

      .subscribe(
        (result) => {
          callback(result);
        },
        (error) => {
          console.log('error', error);
        }
      );
  }

  setErrorMessage(msg = '') {
    this.errorMessage = msg;
  }

  clearErrorMessage() {
    this.setErrorMessage('');
  }

  ngOnDestroy() {
    clearInterval(this.sid);
  }
}
